import React, { useState } from 'react';
import { Form, Checkbox, Col } from 'antd';
import PropTypes from 'prop-types';

const CsvForm = React.memo(
  ({ formId, handleSubmitNormal, handleSubmitTech, enableTechExport }) => {
    const [form] = Form.useForm();
    const [selectedOption, setSelectedOption] = useState('all');

    const handleSubmitForm = () => {
      if (selectedOption === 'all') {
        handleSubmitNormal();
      } else if (selectedOption === 'skills') {
        handleSubmitTech();
      }
    };

    return (
      <Form
        layout="vertical"
        id={formId}
        form={form}
        onFinish={handleSubmitForm}
      >
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 8,
          }}
        >
          <Checkbox
            checked={selectedOption === 'all'}
            onChange={() => setSelectedOption('all')}
          >
            Todos os dados do soluter
          </Checkbox>

          <Checkbox
            disabled={enableTechExport}
            style={{ margin: '0' }}
            checked={selectedOption === 'skills'}
            onChange={() => setSelectedOption('skills')}
          >
            Somente as competências técnicas do soluter
          </Checkbox>
        </Col>
      </Form>
    );
  },
);

export default CsvForm;

CsvForm.propTypes = {
  formId: PropTypes.string.isRequired,
  handleSubmitNormal: PropTypes.func,
  enableTechExport: PropTypes.bool.isRequired,
  handleSubmitTech: PropTypes.func,
};

CsvForm.defaultProps = {
  handleSubmitTech: () => {},
  handleSubmitNormal: () => {},
};
